module.exports = __webpack_public_path__ + "static/logo_transparent-64b844caaa69862ea6feb69c8a1c2673.png";